import type { CreativeBriefResponse } from '@innovationdepartment/proxima-sdk-axios';
import React from 'react';

import {
  CardDivider,
  CardSection,
  CardSectionLabel,
  CardSectionLabelBold,
  CardSectionText
} from '../styles/briefPanel.styles';

type BuyerInsightsSectionProps = {
  buyerInsights: CreativeBriefResponse['buyerInsights'];
};

const BuyerInsightsSection = ({ buyerInsights }: BuyerInsightsSectionProps) => {
  const sections: Array<{ label: string; bold: boolean; narratives: string[] }> = [];
  if (buyerInsights.demographics.length > 0) {
    sections.push({ label: 'Demographics', bold: false, narratives: buyerInsights.demographics });
  }
  if (buyerInsights.location.length > 0) {
    sections.push({ label: 'Location', bold: true, narratives: buyerInsights.location });
  }
  if (buyerInsights.brandSignals.length > 0) {
    sections.push({ label: 'Brand Signals', bold: false, narratives: buyerInsights.brandSignals });
  }

  if (sections.length === 0) return null;

  return (
    <>
      {sections.map((section, idx) => (
        <React.Fragment key={section.label}>
          {idx > 0 && <CardDivider />}
          <CardSection>
            {section.bold ? (
              <CardSectionLabelBold>{section.label}</CardSectionLabelBold>
            ) : (
              <CardSectionLabel>{section.label}</CardSectionLabel>
            )}
            {section.narratives.map((narrative, i, arr) => {
              const occurrence = arr.slice(0, i).filter(n => n === narrative).length;
              return (
                <CardSectionText key={`${section.label}-${narrative}-${occurrence}`}>
                  {narrative}
                </CardSectionText>
              );
            })}
          </CardSection>
        </React.Fragment>
      ))}
    </>
  );
};

export default BuyerInsightsSection;
